import React from 'react';

export const Icons  = () => {
  return (
    <div className="icons-container"> 
      <img className="heart-icon icons" src="../icons/heart.svg" alt="heart-icon" />
      <img className="play-icon icons" src="../icons/play.svg" alt="play-icon" />
      <img className="dots-icon icons" src="../icons/dots.svg" alt="dots-icon" />
    </div>
  );
};